import { SelectProps } from "antd";
import useAuth from "../../hooks/useAuth";
import SelectOffice from "./SelectOffice";

interface FilterOfficeProps extends SelectProps {
	value?: string;
	onChange?: (value: string) => void;
	showOfficeCode?: boolean;
	isIncludeFO?: boolean;
}
const FilterOffice: React.FC<FilterOfficeProps> = ({ value, onChange, showOfficeCode = true, isIncludeFO }) => {
	const { isAdminHQPlus, isHQFinance, isFO } = useAuth();

	return isAdminHQPlus || isHQFinance || (isIncludeFO && isFO) ? (
		<SelectOffice
			placeholder="Filter Office"
			value={value}
			onChange={onChange}
			allowClear
			showOfficeCode={showOfficeCode}
		/>
	) : (
		<></>
	);
};
export default FilterOffice;
